
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Calendar, Clock, DollarSign, MapPin, Check, X, MessageSquare } from "lucide-react";

export const BookingsPage = () => {
  const mockBookings = [
    { 
      id: 1, 
      venue: "Club Neon", 
      date: "November 25, 2023", 
      time: "10:00 PM - 2:00 AM", 
      fee: "$350", 
      status: "Confirmed",
      details: "Headline DJ set with full equipment provided."
    },
    { 
      id: 2, 
      venue: "Skyline Lounge", 
      date: "December 5, 2023", 
      time: "9:00 PM - 1:00 AM", 
      fee: "$275", 
      status: "Pending",
      details: "Opening set, bring your own headphones."
    },
    { 
      id: 3, 
      venue: "The Basement", 
      date: "December 15, 2023", 
      time: "8:00 PM - 12:00 AM", 
      fee: "$300", 
      status: "Pending",
      details: "Back-to-back set with DJ Max."
    },
  ];

  return (
    <div className="container mx-auto p-6 max-w-6xl">
      <div className="flex justify-between items-center mb-8">
        <h1 className="text-3xl font-bold">Booking Requests</h1>
        <Button variant="default">
          <Calendar className="mr-2 h-4 w-4" />
          View Calendar
        </Button>
      </div>

      <Tabs defaultValue="all">
        <TabsList className="w-full justify-start mb-6">
          <TabsTrigger value="all">All Bookings</TabsTrigger>
          <TabsTrigger value="confirmed">Confirmed</TabsTrigger>
          <TabsTrigger value="pending">Pending</TabsTrigger>
          <TabsTrigger value="archived">Archived</TabsTrigger>
        </TabsList>

        <TabsContent value="all" className="space-y-6">
          {mockBookings.map((booking) => (
            <Card key={booking.id}>
              <CardHeader>
                <div className="flex flex-col md:flex-row md:items-center justify-between">
                  <div>
                    <CardTitle className="text-xl">{booking.venue}</CardTitle>
                    <CardDescription className="flex items-center gap-2 mt-1">
                      <MapPin className="h-4 w-4" />
                      <span>123 Main St, Downtown</span>
                    </CardDescription>
                  </div>
                  <div className="mt-2 md:mt-0">
                    <span className={`px-3 py-1 rounded-full text-xs ${
                      booking.status === "Confirmed" 
                        ? "bg-green-100 text-green-800" 
                        : "bg-amber-100 text-amber-800"
                    }`}>
                      {booking.status}
                    </span>
                  </div>
                </div>
              </CardHeader>
              <CardContent>
                <div className="grid md:grid-cols-3 gap-4 mb-4">
                  <div>
                    <div className="text-muted-foreground text-sm mb-1">Date</div>
                    <div className="flex items-center gap-2">
                      <Calendar className="h-4 w-4" />
                      {booking.date}
                    </div>
                  </div>
                  <div>
                    <div className="text-muted-foreground text-sm mb-1">Time</div>
                    <div className="flex items-center gap-2">
                      <Clock className="h-4 w-4" />
                      {booking.time}
                    </div>
                  </div>
                  <div>
                    <div className="text-muted-foreground text-sm mb-1">Booking Fee</div>
                    <div className="flex items-center gap-2">
                      <DollarSign className="h-4 w-4" />
                      {booking.fee}
                    </div>
                  </div>
                </div>

                <div className="mb-4">
                  <div className="text-muted-foreground text-sm mb-1">Details</div>
                  <p>{booking.details}</p>
                </div>

                <div className="flex justify-end gap-2">
                  <Button variant="outline" size="sm">
                    <MessageSquare className="h-4 w-4 mr-2" />
                    Message
                  </Button>
                  {booking.status === "Pending" ? (
                    <>
                      <Button variant="outline" size="sm" className="text-red-600 border-red-200 hover:bg-red-50 hover:text-red-700">
                        <X className="h-4 w-4 mr-2" />
                        Decline
                      </Button>
                      <Button variant="default" size="sm">
                        <Check className="h-4 w-4 mr-2" />
                        Accept
                      </Button>
                    </>
                  ) : (
                    <Button variant="default" size="sm">
                      View Details
                    </Button>
                  )}
                </div>
              </CardContent>
            </Card>
          ))}
        </TabsContent>

        <TabsContent value="confirmed" className="space-y-6">
          {mockBookings
            .filter(booking => booking.status === "Confirmed")
            .map((booking) => (
              <Card key={booking.id}>
                <CardHeader>
                  <div className="flex flex-col md:flex-row md:items-center justify-between">
                    <div>
                      <CardTitle className="text-xl">{booking.venue}</CardTitle>
                      <CardDescription className="flex items-center gap-2 mt-1">
                        <MapPin className="h-4 w-4" />
                        <span>123 Main St, Downtown</span>
                      </CardDescription>
                    </div>
                    <div className="mt-2 md:mt-0">
                      <span className="px-3 py-1 rounded-full text-xs bg-green-100 text-green-800">
                        Confirmed
                      </span>
                    </div>
                  </div>
                </CardHeader>
                <CardContent>
                  <div className="grid md:grid-cols-3 gap-4 mb-4">
                    <div>
                      <div className="text-muted-foreground text-sm mb-1">Date</div>
                      <div className="flex items-center gap-2">
                        <Calendar className="h-4 w-4" />
                        {booking.date}
                      </div>
                    </div>
                    <div>
                      <div className="text-muted-foreground text-sm mb-1">Time</div>
                      <div className="flex items-center gap-2">
                        <Clock className="h-4 w-4" />
                        {booking.time}
                      </div>
                    </div>
                    <div>
                      <div className="text-muted-foreground text-sm mb-1">Booking Fee</div>
                      <div className="flex items-center gap-2">
                        <DollarSign className="h-4 w-4" />
                        {booking.fee}
                      </div>
                    </div>
                  </div>

                  <div className="mb-4">
                    <div className="text-muted-foreground text-sm mb-1">Details</div>
                    <p>{booking.details}</p>
                  </div>

                  <div className="flex justify-end gap-2">
                    <Button variant="outline" size="sm">
                      <MessageSquare className="h-4 w-4 mr-2" />
                      Message
                    </Button>
                    <Button variant="default" size="sm">
                      View Details
                    </Button>
                  </div>
                </CardContent>
              </Card>
            ))}
        </TabsContent>

        <TabsContent value="pending" className="space-y-6">
          {mockBookings
            .filter(booking => booking.status === "Pending")
            .map((booking) => (
              <Card key={booking.id}>
                <CardHeader>
                  <div className="flex flex-col md:flex-row md:items-center justify-between">
                    <div>
                      <CardTitle className="text-xl">{booking.venue}</CardTitle>
                      <CardDescription className="flex items-center gap-2 mt-1">
                        <MapPin className="h-4 w-4" />
                        <span>123 Main St, Downtown</span>
                      </CardDescription>
                    </div>
                    <div className="mt-2 md:mt-0">
                      <span className="px-3 py-1 rounded-full text-xs bg-amber-100 text-amber-800">
                        Pending
                      </span>
                    </div>
                  </div>
                </CardHeader>
                <CardContent>
                  <div className="grid md:grid-cols-3 gap-4 mb-4">
                    <div>
                      <div className="text-muted-foreground text-sm mb-1">Date</div>
                      <div className="flex items-center gap-2">
                        <Calendar className="h-4 w-4" />
                        {booking.date}
                      </div>
                    </div>
                    <div>
                      <div className="text-muted-foreground text-sm mb-1">Time</div>
                      <div className="flex items-center gap-2">
                        <Clock className="h-4 w-4" />
                        {booking.time}
                      </div>
                    </div>
                    <div>
                      <div className="text-muted-foreground text-sm mb-1">Booking Fee</div>
                      <div className="flex items-center gap-2">
                        <DollarSign className="h-4 w-4" />
                        {booking.fee}
                      </div>
                    </div>
                  </div>

                  <div className="mb-4">
                    <div className="text-muted-foreground text-sm mb-1">Details</div>
                    <p>{booking.details}</p>
                  </div>

                  <div className="flex justify-end gap-2">
                    <Button variant="outline" size="sm">
                      <MessageSquare className="h-4 w-4 mr-2" />
                      Message
                    </Button>
                    <Button variant="outline" size="sm" className="text-red-600 border-red-200 hover:bg-red-50 hover:text-red-700">
                      <X className="h-4 w-4 mr-2" />
                      Decline
                    </Button>
                    <Button variant="default" size="sm">
                      <Check className="h-4 w-4 mr-2" />
                      Accept
                    </Button>
                  </div>
                </CardContent>
              </Card>
            ))}
        </TabsContent>

        <TabsContent value="archived" className="space-y-6">
          <Card>
            <CardContent className="flex items-center justify-center py-6">
              <p className="text-muted-foreground">No archived bookings found</p>
            </CardContent>
          </Card>
        </TabsContent>
      </Tabs>
    </div>
  );
};
